module.exports = __webpack_public_path__ + "static/illustration-3-b4dce7ea24792296ae1e7d9115fcb859.svg";